import { loading, throttle, validate } from '@/commons/decorators/decorator';
import { Hospital } from '@/entities/hospital';
import { PhysicalInfo } from '@/entities/physical';
import { MARITAL_STATUS } from '@/metas/user';
import physicalService from '@/services/physical.services';
import HospitalFiles from '@/views/form/hospital.files.vue';
import { Field, Form } from 'vant';
import { Component, Vue, Watch } from 'vue-property-decorator';

/**
 * 申请表单
 */
@Component({ name: 'ApplicationForm',
    components: {
        HospitalFiles,
    },
})
export default class extends Vue {
    public $refs!: { form: Form };

    // 体检信息
    public physicalInfo: PhysicalInfo | null = null;

    // 所选医院体检额度
    public amount: number | null = null;

    public loading: boolean = false;

    public MARITAL_STATUS = MARITAL_STATUS;

    @loading()
    public created() {
        this.getUserInfo();
    }

    /**
     * 获取用户信息 医院信息
     */
    public async getUserInfo() {
        this.physicalInfo = await physicalService.getInfo();
    }

    @Watch('physicalInfo.hospitalNameOfThisYear')
    public async getAmount() {
        if (!this.physicalInfo?.hospitalNameOfThisYear) { return; }
        const hospitalId = this.physicalInfo?.hospitals.find(h => h.hospitalName === this.physicalInfo?.hospitalNameOfThisYear)?.hospitalId;
        if (hospitalId) {
            const res = await physicalService.getAmountByHospitalId(hospitalId);
            if (Number(res.message) >= 0) {
                this.amount = res.message;
            } else {
                this.$notify({ type: 'danger', message: res.message, duration: 3000 });
            }
        }
    }
}
